export const editSnippetModal = {
  extend: '/add-snippet-modal',
  ModalHeader: {
    title: 'Edit {{ key }} snippet'
  },
  Flex: {},
  ModalFooter: {
    CheckButton: {
      type: 'submit',
      icon: 'checkmark',
      text: '{{ common.action.save | polyglot }}'
    },
    IconButton: {
      icon: 'trash outline',
      onClick: (ev, el, s, ctx) => {
        // The item key comes from the route, the same read `on.init` makes —
        // a bare `key` here was never bound (a ReferenceError locally, and a
        // read off the shared globalScope once published).
        const key = el.call('getLastLocationPath').slice(1)
        const text = 'Do you want to remove the snippet?'
        if (key && window.confirm(text)) {
          el.removeItem(s.parse())
          el.call('closeRouterModal', el, s, ctx)
        }
      }
    }
  },
  on: {
    init: (el, s, ctx) => {
      const key = el.call('getLastLocationPath').slice(1)
      const item = el.getItem(key)
      return item && s.quietReplace(item)
    },
    submit: (e, el, s, ctx) => {
      e.preventDefault()
      el.updateItem(s.parse())
      ctx.utils.closeModal(el, s, ctx)
    }
  }
}
